const IframeTestPage = () => {
    return(
            <iframe 
            src="https://secure4.paymentus.com/rotp/GDCH?itok=651CE254B7A6DE99C55485DC47CD8FEC95C388D77055EBE2228F0E19D7FD6DC04425AFBAA0EFACB8850A2F403A3F582E6E5E39461C170196C0201348FD2414831008DF5C55947B35473D7079CC9FE0B3B46131F565519CD66698E84DD96318B081F8768F455E07C4F14E9E931D808928A0A8BC9AA65DE54248EDBB1B307428F8B3D28E2CBE9BE60C30FF3764C92A6167108656D230FF66C091E75F6CF91DEE6F3C9E082871050FE176557BE786C34378110ADAC3A4B0F831A1C8380CCD9EDFD6749915573EF2E908C918E45CE47869A16CB48D35A93D77590AF246D6F159EC55" 
            height="100%" 
            width="100%" 
            title="Iframe Example"
            />
    )
}
export default IframeTestPage;